module.exports = __webpack_public_path__ + "b66aec93a507885fc78c3b667924e38d.pdf";